import {
    EntityState,
    EntityStore,
    StoreConfig,
    arrayAdd,
    arrayRemove,
} from "@datorama/akita";
import { singleton } from "tsyringe";

import { WishlistProductStatusEntity } from "../entities/WishlistProductStatusEntity";

export interface WishlistProductStatusesState
    extends EntityState<WishlistProductStatusEntity, number> {
    productsInLoading: number[];
}

export function createInitialState(): WishlistProductStatusesState {
    return {
        productsInLoading: [],
    };
}

@singleton()
@StoreConfig({ name: "WishlistProductStatusesStore", idKey: "productId" })
export class WishlistProductStatusesStore extends EntityStore<WishlistProductStatusesState> {
    constructor() {
        super(createInitialState());
    }

    public setLoadingStatus(productId: number) {
        this.update(({ productsInLoading }) => ({
            productsInLoading: arrayAdd(productsInLoading, productId),
        }));
    }

    public unsetLoadingStatus(productId: number) {
        this.update(({ productsInLoading }) => ({
            productsInLoading: arrayRemove(
                productsInLoading,
                (v: number) => v === productId
            ),
        }));
    }
}
